import React from 'react';

import { Link } from 'react-router-dom';

import { ContentTitle } from '../../../../components/utilities/styledComponents/ContentTitle';

import { Container } from './style';
import FormAdsTemplate from '../../../../components/FormAdsTemplate';

const Creation = () => (
	<Container>
		<ContentTitle className="d-flex justify-content-between">
			<div>
				<h1>Template de anúncio</h1>
			</div>
		</ContentTitle>

		<nav>
			<Link to="/backoffice/templates" className="link-back">
				{'< Voltar para listagem'}
			</Link>
		</nav>

		<section className="box">
			<div className="d-flex align-items-center">
				<i className="fas fa-columns" />
				<h2>Cadastro de template</h2>
			</div>
			<FormAdsTemplate
				redirectSuccess="/backoffice/templates"
				messageSuccess="Template de anúncio criado com sucesso."
				btnText="Cadastrar template"
			/>
		</section>
	</Container>
);

export default Creation;
